export default __webpack_public_path__ + "static/media/showOnHome.9fe6920c.svg";